export default "__VITE_ASSET__CNPCwZuF__"